module.exports = __webpack_public_path__ + "img/140.2b7a3ad6.jpg";